/**
 * Section assignment helper. Given an exercise id + its library definition,
 * returns the appropriate section ("warmup" | "workout" | "cooldown") so
 * the auto-suggest blueprint can land plyos in warm-up, main lifts in the
 * workout block, and stretches in the cool-down.
 */

// Plyometric / power IDs (used as the warm-up CNS prime in every focus blueprint).
const PLYO_IDS = new Set([
  "box-jump", "broad-jump", "jump-squat", "depth-jump", "split-squat-jump",
  "trap-bar-jump", "box-jump-intervals", "tuck-jump", "knee-tuck-jump",
  "single-leg-broad-jump", "hurdle-hop", "drop-jump", "jump-lunge",
  "single-leg-box-jump", "burpee-broad-jump",
  "clap-pushup", "plyo-pushup", "medball-slam", "standing-power-throw",
  "mb-rotational-throw", "mb-overhead-throw", "mb-chest-pass",
  "pogo-hop", "ankle-hop", "lateral-bound", "skater-jump", "power-skip",
  "jump-rope", "kettlebell-swing",
]);

// Cool-down IDs: explicit stretches, foam rolling, mobility flows, etc.
const COOLDOWN_PATTERN = /(stretch|foam-roll|tspine|wall-angels|pancake|scorpion|childs-pose|down-?dog|cobra|pigeon|figure-?4|happy-baby|cat-?cow|hip-flexor|world|90-?90|banded-shoulder)/i;

const COOLDOWN_IDS = new Set([
  "couch-stretch", "worlds-greatest-stretch", "downward-dog", "pigeon-pose",
  "child-pose", "childs-pose", "cobra", "figure-4-stretch", "happy-baby",
  "cat-cow", "doorway-chest-stretch", "wall-angels", "banded-shoulder-dislocates",
  "pancake-stretch", "scorpion-stretch", "foam-roll-tspine", "foam-roll-quads",
  "foam-roll-glutes", "foam-roll-it-band", "90-90-hip-stretch",
  "lying-spinal-twist", "hip-flexor-stretch", "hamstring-stretch",
]);

export function autoAssignSection(exerciseId, exDef = null) {
  if (!exerciseId) return "workout";
  if (PLYO_IDS.has(exerciseId)) return "warmup";
  if (COOLDOWN_IDS.has(exerciseId)) return "cooldown";
  if (COOLDOWN_PATTERN.test(exerciseId)) return "cooldown";
  // Mobility-domain drills always cool-down unless they're a dynamic
  // priming drill (which the PLYO_IDS list catches first).
  if (exDef?.domain === "Mobility") return "cooldown";
  if (exDef?.domain === "Recovery") return "cooldown";
  return "workout";
}
